import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BudgetGroupSearch, IBudgetGroup } from '../budget-groups/budget-groups.model';

@Injectable({
    providedIn: 'root',
})
export class BudgetGroupService {
    baseUrl = '/school-service/api/budget-groups';

    constructor(private http: HttpClient) {
        console.log('Budget Group service created');
    }

    getBudgetGroups(): Observable<IBudgetGroup[]> {
        return this.http.get<IBudgetGroup[]>(this.baseUrl);
    }

    getActiveBudgetGroups(): Observable<IBudgetGroup[]> {
        return this.http.get<IBudgetGroup[]>(`${this.baseUrl}/active`);
    }

    deleteBudgetGroup(budgetGroup: IBudgetGroup): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${budgetGroup.id}`, { observe: 'response' });
    }

    createBudgetGroup(budgetGroup: IBudgetGroup): Observable<HttpResponse<IBudgetGroup>> {
        return this.http.post<IBudgetGroup>(this.baseUrl, budgetGroup, { observe: 'response' });
    }

    updateBudgetGroup(budgetGroup: IBudgetGroup): Observable<HttpResponse<IBudgetGroup>> {
        return this.http.put<IBudgetGroup>(this.baseUrl, budgetGroup, { observe: 'response' });
    }

    searchBudgetGroups(search: BudgetGroupSearch): Observable<HttpResponse<IBudgetGroup[]>> {
        return this.http.post<IBudgetGroup[]>(`${this.baseUrl}/search`, search, { observe: 'response' });
    }
}
